import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ml-3" }
const _hoisted_2 = { class: "mt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", {
  class: "nav nav-tabs",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link active",
      id: "current-assets-tab",
      "data-toggle": "tab",
      "aria-selected": "true",
      href: "#current-assets-setting",
      role: "tab",
      "aria-controls": "current-assets-setting"
    }, "流動資産科目")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "fix-assets-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#fix-assets-setting",
      role: "tab",
      "aria-controls": "fix-assets-setting"
    }, "固定資産科目")
  ]),
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "nav-link",
      id: "total-debt-tab",
      "data-toggle": "tab",
      "aria-selected": "false",
      href: "#total-debt-setting",
      role: "tab",
      "aria-controls": "total-debt-setting"
    }, "負債合計科目")
  ])
], -1)
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = {
  class: "tab-pane fade show active",
  id: "current-assets-setting",
  role: "tabpanel",
  "aria-labelledby": "current-assets-tab"
}
const _hoisted_6 = {
  class: "tab-pane fade",
  id: "fix-assets-setting",
  role: "tabpanel",
  "aria-labelledby": "fix-assets-tab"
}
const _hoisted_7 = {
  class: "tab-pane fade",
  id: "total-debt-setting",
  role: "tabpanel",
  "aria-labelledby": "total-debt-tab"
}
const _hoisted_8 = { class: "mt-5 p-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "資産の状況", -1)
const _hoisted_10 = { class: "p-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", null, "土地", -1)
const _hoisted_12 = { class: "form-check form-check-inline" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "land-corporation"
}, "法人所有", -1)
const _hoisted_14 = { class: "form-check form-check-inline" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "land-lease"
}, "賃借", -1)
const _hoisted_16 = { class: "form-check form-check-inline" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "land-partially-owned"
}, "部分的に法人所有（部分的に賃借）", -1)
const _hoisted_18 = { class: "mt-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h5", null, "建物", -1)
const _hoisted_20 = { class: "form-check form-check-inline" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "building-corporation"
}, "法人所有", -1)
const _hoisted_22 = { class: "form-check form-check-inline" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "building-lease"
}, "賃借", -1)
const _hoisted_24 = { class: "form-check form-check-inline" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "building-partially-owned"
}, "部分的に法人所有（部分的に賃借）", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kaikei_kijun_setting_title = _resolveComponent("kaikei-kijun-setting-title")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_response_result_alert = _resolveComponent("response-result-alert")!
  const _component_setting_panel = _resolveComponent("setting-panel")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, { loading: _ctx.loading }, {
    header: _withCtx(() => [
      _createVNode(_component_kaikei_kijun_setting_title, { "main-title": "財産目録" })
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_loading_button, {
          color: "primary",
          onClick: _ctx.onClickRegister,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode("登録")
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      _createVNode(_component_response_result_alert, {
        class: "mt-3",
        "is-succeed": _ctx.isSucceedResponse,
        "error-message": _ctx.requestError,
        onDismiss: _ctx.onDismissAlert
      }, null, 8, ["is-succeed", "error-message", "onDismiss"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_setting_panel, {
              "response-setting-item": _ctx.currentAssetsSetting,
              onUpdateSettingItem: _ctx.onUpdatedSetting,
              "panel-name": "CurrentAssets"
            }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_setting_panel, {
              "response-setting-item": _ctx.fixAssetsSetting,
              onUpdateSettingItem: _ctx.onUpdatedSetting,
              "panel-name": "FixAssets"
            }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_setting_panel, {
              "response-setting-item": _ctx.totalDebtSetting,
              onUpdateSettingItem: _ctx.onUpdatedSetting,
              "panel-name": "TotalDebt"
            }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                value: "Corporation",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.landOwnershipStatus) = $event)),
                id: "land-corporation"
              }, null, 512), [
                [_vModelRadio, _ctx.landOwnershipStatus]
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                value: "Lease",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.landOwnershipStatus) = $event)),
                id: "land-lease"
              }, null, 512), [
                [_vModelRadio, _ctx.landOwnershipStatus]
              ]),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                value: "PartiallyOwned",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.landOwnershipStatus) = $event)),
                id: "land-partially-owned"
              }, null, 512), [
                [_vModelRadio, _ctx.landOwnershipStatus]
              ]),
              _hoisted_17
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                value: "Corporation",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.buildingOwnershipStatus) = $event)),
                id: "building-corporation"
              }, null, 512), [
                [_vModelRadio, _ctx.buildingOwnershipStatus]
              ]),
              _hoisted_21
            ]),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                value: "Lease",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.buildingOwnershipStatus) = $event)),
                id: "building-lease"
              }, null, 512), [
                [_vModelRadio, _ctx.buildingOwnershipStatus]
              ]),
              _hoisted_23
            ]),
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                value: "PartiallyOwned",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.buildingOwnershipStatus) = $event)),
                id: "building-partially-owned"
              }, null, 512), [
                [_vModelRadio, _ctx.buildingOwnershipStatus]
              ]),
              _hoisted_25
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}